<template lang="pug">
van-nav-bar(:title='dwgFileName' fixed :left-arrow="hasLeft" @click-left='onClickLeft' )
  template(#right)
    van-icon(name='setting-o' color='#464646' size='20' @click="openOther('set')")
</template>

<script>
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  computed: {
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    isLoginFree() {
      return this.$route.query.isLoginFree || "";
    },
    hasLeft() {
      return !this.$route.query.i;
    },
    dwgFileName() {
      return decodeURIComponent(this.dwgdata.fileName) || "未命名";
    }
  },
  methods: {
    // 头部按钮返回
    onClickLeft() {
      const data = { source: "back" };
      let { isH5 } = this.$route.query || {};
      mongeApiMlib.rebackLastPage(this.isLoginFree || isH5, data);
    },
    openOther() {
      this.$emit("openOther", "set");
    }
  }
};
</script>

<style lang="scss" scoped>
.van-nav-bar__content {
  height: 88upx;
}
</style>
